import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "../../../assets/images/AppBar/search.png";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import React, { FormEvent, useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";
import { Tooltip } from "@mui/material";

type Props = {
  placeholder: string;
  onSearch: (text: string) => void;
  searchValue: string;
  minWidth?: string;
  showToolTip?: boolean;
  maxWidth?: string;
  m?: {
    xs: string;
    sm: string;
  };
  p?: string;
  showSearchIcon?: boolean;
  type?: string;
  getOnChange?: boolean;
  onChangeFunction?: (text: string) => void | undefined;
};

export type SearchBarHandle = {
  resetSearch: () => void;
};

const SearchBar = React.forwardRef<SearchBarHandle, Props>(
  (
    {
      placeholder,
      onSearch,
      searchValue,
      minWidth,
      maxWidth,
      m,
      p,
      showSearchIcon = true,
      showToolTip = false,
      type,
      getOnChange = false,
      onChangeFunction = undefined,
    },
    ref,
  ) => {
    const [search, setSearch] = useState(searchValue);

    function onSubmit(event: FormEvent) {
      event.preventDefault();
      event.stopPropagation();
      onSearch(search);
    }
    React.useImperativeHandle(ref, () => ({
      resetSearch() {
        setSearch("");
        onSearch("");
      },
    }));
    const getToolTip = () => {
      if (showToolTip && search.length > 2) {
        return search;
      }
      return null;
    };
    const handleInputBaseChange = (event: any) => {
      setSearch(event.target.value);
      if (getOnChange && onChangeFunction) {
        onChangeFunction(event.target.value);
      }
      if (event.target.value === "") {
        onSearch("");
      }
    };
    return (
      <Tooltip
        title={getToolTip()}
        leaveTouchDelay={7000}
        enterTouchDelay={0}
        arrow
        placement="top"
        followCursor
      >
        <Paper
          component="form"
          sx={{
            m: m || {
              xs: "0.75rem 0",
              sm: "0 1rem",
            },
            p: p || "4px 12px",
            display: "flex",
            alignItems: "center",
            borderRadius: "25px",
            backgroundColor: "rgba(111, 105, 105, 0.07)",
            boxShadow: "none",
            maxWidth: maxWidth || "500px",
            minWidth: minWidth || {
              xs: "200px",
              sm: "200px",
              md: "250px",
              lg: "400px",
            },
            height: "32px",
          }}
          onSubmit={onSubmit}
        >
          {showSearchIcon && (
            <Box
              sx={{ paddingLeft: "4px", display: "flex", alignItems: "center" }}
            >
              <img
                alt="search icon"
                src={SearchIcon}
                width={"14px"}
                style={{ opacity: "0.5" }}
              />
            </Box>
          )}

          <InputBase
            ref={ref}
            value={search}
            type={type || "text"}
            onChange={handleInputBaseChange}
            sx={{
              ml: 0,
              flex: 1,
              fontSize: "12px",
              fontWeight: "500",
              pl: "5px",
              "&::-webkit-search-clear-button": {
                display: "none",
              },
              "&::-webkit-search-cancel-button": {
                display: "none",
              },
            }}
            placeholder={placeholder}
            inputProps={{ "aria-label": "Search bar" }}
          />
          {search && (
            <IconButton
              sx={{
                padding: "2px",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => {
                setSearch("");
                onSearch("");
              }}
            >
              <CloseIcon
                sx={{
                  fontSize: "18px",
                }}
              />
            </IconButton>
          )}
          <IconButton
            sx={{
              padding: "4px",
              display: "flex",
              alignItems: "center",
            }}
            type="submit"
          >
            <SendIcon
              sx={{
                fontSize: "18px",
                color: "rgba(0,0,0,0.5)",
              }}
            />
          </IconButton>
        </Paper>
      </Tooltip>
    );
  },
);

export default SearchBar;
